module.exports = __webpack_public_path__ + "static/media/cryptocurrency-infographic.729e3f8c.jpg";